import gsap from 'gsap';

var HEADER_DELAY_AFTER_VIDEO_MS = 1500;
var HEADER_REVEAL_DURATION = 1;
var HEADER_REVEAL_OFFSET = -100;
var headerRevealTimer = null;
var headerRevealStarted = false;

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function dispatchCamstEvent(name, detail) {
  if (!window.CustomEvent) {
    return;
  }

  window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
}

function getHeaderMotion(header) {
  return header ? header.querySelector('.camst-header__motion') : null;
}

function finishHeaderReveal(header, motion) {
  header.classList.remove('is-revealing');
  header.classList.add('is-visible');

  if (motion) {
    gsap.set(motion, { clearProps: 'transform' });
  }
}

export function showCamstHeaderInstantly(header) {
  var motion = getHeaderMotion(header);

  if (!header) {
    return;
  }

  header.dataset.camstHeaderRevealed = 'true';
  header.classList.remove('is-revealing');
  header.classList.add('is-visible');
  gsap.set(header, { opacity: 1 });

  if (motion) {
    gsap.set(motion, { clearProps: 'transform' });
  }
}

export function animateCamstHeaderIn(header, options) {
  var motion = getHeaderMotion(header);
  var settings = options || {};

  if (!header || !motion || header.dataset.camstHeaderRevealed === 'true') {
    return false;
  }

  header.dataset.camstHeaderRevealed = 'true';

  if (prefersReducedMotion()) {
    gsap.set(header, { opacity: 1 });
    finishHeaderReveal(header, motion);

    if (typeof settings.onComplete === 'function') {
      settings.onComplete();
    }

    return true;
  }

  header.classList.add('is-revealing');
  gsap.set(header, { opacity: 1 });
  gsap.set(motion, { y: HEADER_REVEAL_OFFSET });

  gsap.to(motion, {
    y: 0,
    duration: settings.duration || HEADER_REVEAL_DURATION,
    ease: 'power3.out',
    onComplete: function () {
      finishHeaderReveal(header, motion);

      if (typeof settings.onComplete === 'function') {
        settings.onComplete();
      }
    },
  });

  return true;
}

export function revealCamstHeader() {
  var header = document.querySelector('[data-camst-header]');

  if (!header) {
    return;
  }

  document.body.classList.add('camst-header-visible');
  document.body.classList.remove('camst-header-await-preloader');

  animateCamstHeaderIn(header, {
    onComplete: function () {
      dispatchCamstEvent('camst:header:revealed', {});
    },
  });
}

function scheduleHeaderReveal() {
  if (headerRevealStarted) {
    return;
  }

  headerRevealStarted = true;

  if (headerRevealTimer) {
    window.clearTimeout(headerRevealTimer);
  }

  headerRevealTimer = window.setTimeout(function () {
    revealCamstHeader();
  }, HEADER_DELAY_AFTER_VIDEO_MS);
}

function hasHeroVideoStarted() {
  return document.body.classList.contains('camst-hero-video-started');
}

export function initCamstHeaderReveal() {
  window.addEventListener('camst:hero:video-started', scheduleHeaderReveal);

  // Con il preloader gia' concluso l'hero emette l'evento durante il proprio
  // init, prima che questo listener esista: senza recupero l'header resterebbe
  // invisibile per tutta la visita.
  if (hasHeroVideoStarted()) {
    scheduleHeaderReveal();
  }
}
